module.exports = __webpack_public_path__ + "static/media/blog.edf1460a.png";